import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.automatic-alerts-form', () => {
  import('./internal/automatic-alerts-form').then(({ default: Component }) => Component());
});
